import React, {ReactNode, Suspense} from 'react';
import {StyledEngineProvider} from '@mui/joy/styles';
import {SnackbarProvider} from 'notistack';
import {observer} from 'mobx-react-lite';


import '../figma-variables/palette.css';
import '../figma-variables/light.css';
import '../figma-variables/dark.css';
import '../figma-variables/text.css';


import './common.css';
import './Snackbar.css';


import {Layout} from './ui/elements/Layout';

import {SnackbarBlock} from "./ui/components/SnackbarBlock";
import {AuthModalsManager} from "./ui/screens/modals/auth/AuthModalsManager";
import { useRootStore, useUserState } from "@stores/AppStateContext";


const Theme: React.FunctionComponent<{ children: ReactNode }> = observer(({children}) => {
    const rootStore = useRootStore();
    const userState = useUserState();
    
    return (
        <div
            key={userState?.user?.["custom:clientId"]}
            className={rootStore.darkTheme ? 'theme-dark' : ''}>{children}</div>
    )
});


/*
* z-index levels:
* 5000 - snackbar
* 4750 - tooltips
* 4500 - context menu
* 4000 - modal windows
* 3000 - settings menu overlay
* 1000 - header menu
* 500 - context menu in Editor
*/
function App() {
    return (
        <SnackbarProvider
            classes={{
                containerRoot: 'SnackbarRoot',
                root: 'Snackbar',
            }}
            Components={{
                default: SnackbarBlock,
                info: SnackbarBlock,
                error: SnackbarBlock,
                warning: SnackbarBlock,
                success: SnackbarBlock,
                // @ts-ignore
                primary: SnackbarBlock,
                ai: SnackbarBlock,
            }}
            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
        >
            <StyledEngineProvider injectFirst>
                <Theme>
                    <Layout/>
                    <AuthModalsManager/>
                </Theme>
            </StyledEngineProvider>
        </SnackbarProvider>
    );
}

export default App;
